import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const ChargingHistoryCardIcon = ({ primaryColor = '#414042', strokeColor = '#414042', size, style, secondaryColor, textColor, ...rest }) => (
    <SvgIcon viewBox='0 0 11.3 11.3' style={size ? { ...style, fontSize: size, width: size, height: size } : style} {...rest}>
        <path
            fill={primaryColor}
            d='M2.91,7.1c-.08,0-.14.06-.14.13,0,.08.06.14.13.14h.75c.08,0,.14-.06.14-.13,0-.08-.06-.14-.13-.14h-.75ZM2.91,6.35c-.08,0-.14.06-.14.13,0,.08.06.14.13.14h1.74c.08,0,.14-.07.13-.14,0-.07-.06-.13-.13-.13h-1.73ZM2.07,5.45h7.16v2.24c0,.28-.22.5-.5.5H2.57c-.28,0-.5-.22-.5-.5v-2.24ZM2.07,4.49h7.16v.68H2.07v-.68ZM2.57,3.11h6.16c.28,0,.5.22.5.5v.61H2.07v-.61c0-.28.22-.5.5-.5M2.57,2.83c-.43,0-.78.35-.78.77v4.09c0,.43.35.77.78.77h6.16c.43,0,.78-.35.78-.77V3.6c0-.43-.35-.77-.78-.77H2.57Z'
        />
        <rect x='2.07' y='4.49' width='7.15' height='.69' fill={primaryColor} />
        <circle cx='5.65' cy='5.65' r='5.48' fill='none' stroke={strokeColor} strokeWidth='0.34' />
    </SvgIcon>
);

export default ChargingHistoryCardIcon;
